import { useFormikContext } from "formik";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { couponCodeAtom, userInfoAtom } from "src/atoms";
import { useMyServiceBill } from "src/hooks/api/bill/useMyServiceBill";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { useApiError } from "src/hooks/useApiError";
import { createServiceInicisBill, updateCompanyName } from "src/service/pay";
import { notifyError } from "src/components/Common/Toast";
import { insertInicisModule } from "src/utils/pay/insertInicisModuleNew";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";

export interface IPayDataType {
  buyerEmail: string;
  buyerName: string;
  // couponCode: string;
  customerUid: string;
  discountPrice: number;
  mKey: string;
  merchantUid: string;
  mid: string;
  oid: string;
  price: string;
  signature: string;
  timestamp: string;
  couponCode: string;
}
interface IReactInicis {
  payData: IPayDataType;
  currency: string;
  confirmPolicy?: boolean;
  isPurchase?: boolean;
  isCardChange?: boolean; // 결제 카드 교체 여부
  goodName: string;
  returnUrl?: string;
  // closeUrl: string;
  children: ReactNode;
  // isValidation: () => Promise<boolean>;
}

// PC 결제수단 반환
const payServerText = (index: number) => {
  if (index === 0) {
    return "Card"; // 카드
  } else if (index === 1) {
    return "VBank"; // 무통장
  } else if (index === 2) {
    return "HPP"; // 핸드폰
  } else if (index === 3) {
    return "DirectBank"; // 계좌이체
  }
};

// Mobile 결제수단 반환
const payServerTextMb = (index: number) => {
  if (index === 0) {
    return "CARD"; // 카드
  } else if (index === 1) {
    return "VBANK"; // 무통장
  } else if (index === 2) {
    return "MOBILE"; // 핸드폰
  } else if (index === 3) {
    return "BANK"; // 계좌이체
  }
};

const ReactInicis = ({
  payData,
  currency,
  isPurchase,
  confirmPolicy,
  isCardChange = false,
  goodName,
  returnUrl = window.location.origin +
    "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
    payData?.oid +
    "/" +
    window.sessionStorage.getItem("product"),
  children,
}: IReactInicis) => {
  // const mobilePurchaseRef = useRef();
  // const [timestamp, setTimestamp] = useState(0);
  // const [oid, setOid] = useState(0);
  // const isTest = window.location.hostname !== "cloudportal.fasoo.com";
  const [resolvedReturnUrl, setResolvedReturnUrl] = useState<string>("");
  const { lang } = useRouter();
  const closeUrl = window.location.href;
  const { values, setFieldValue, isValid } = useFormikContext<any>();
  const { isOciProduct } = useIsOciProduct();
  const { myServiceBill } = useMyServiceBill({});
  // const [price, setPrice] = useState<string>(payData?.price);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [couponCodeInfo, setCouponCodeInfo] = useRecoilState(couponCodeAtom);
  const { handleError } = useApiError();
  // 구매하기 버튼 클릭
  useEffect(() => {
    if (payData?.oid) {
      setResolvedReturnUrl(
        window.location.origin +
          "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
          payData?.oid +
          "/" +
          window.sessionStorage.getItem("product")
      );
    }
  }, [payData?.oid]);
  useEffect(() => {
    insertInicisModule();
  }, []);
  // useEffect(() => {
  //   if (couponCodeInfo) {
  //     if (couponCodeInfo.discountType === "PERCENT") {
  //       console.log("여기야~", payData?.price, couponCodeInfo);
  //       setPrice(
  //         (
  //           Number(payData?.price) *
  //           (1 - Number(couponCodeInfo.discountPrice) / 100)
  //         ).toString()
  //       );
  //     } else if (couponCodeInfo.discountType === "AMOUNT") {
  //       setPrice(
  //         (
  //           Number(payData?.price) - Number(couponCodeInfo.discountPrice)
  //         ).toString()
  //       );
  //     }
  //   } else {
  //     setPrice(payData?.price);
  //   }
  // }, [couponCodeInfo, payData]);
  const onClickPurchase = useCallback(async () => {
    // console.log("payData", payData);
    // console.log("payData price", payData?.price);
    // const isValid = await isValidation();
    // console.log("isValid", isValid);
    // if (isValid) {
    if (payData) {
      console.log("values", values);
      await createServiceInicisBill({
        serviceBillUid: values?.serviceBillUid,
        // serviceBillUid: "test",
        userCode: userInfo.userCode,
        billType: "PAY",
        billCode: values?.priceUid, // price의 uid값 전달
        licenseCount: values?.licenseCount,
        orderID: payData?.oid,
        subscriptionID: "Inicis",
        payTerm: values?.payTerm,
        startTime: 0,
        oldSubscriptionID: "",
        currency,
        payCompany: "INICIS",
        referralId: values?.referralId,
        nxacAppUids: values?.selectAppList ?? [],
        billNewType: isCardChange ? "CHANGE" : "NEW",

        totalPrice: values?.totalPrice,
        discountPrice: payData?.discountPrice,
        couponCode: payData?.couponCode,
      }).then((res) => {
        // @ts-expect-error
        const INIStdPay = window?.INIStdPay;
        if (!isCardChange && isValid && res?.status === 200) {
          if (isOciProduct && getProductFromSessionStorage() === "WRAPSODY") {
            // 회사명 업데이트
            updateCompanyName({ companyName: values?.companyName });
          }
          let goService = true;
          if (myServiceBill.length > 1) {
            let deleteCount = 0;
            myServiceBill.forEach((bill: any) => {
              if (bill.payStatus === "END") {
                deleteCount++;
              }
            });

            if (myServiceBill.length !== deleteCount + 1) {
              goService = false;
            }
          } else if (myServiceBill.length === 1) {
            myServiceBill.forEach((bill: any) => {
              if (bill.payStatus !== "END") {
                if (
                  bill.billType === "PROMOTION" ||
                  (bill.billType === "PAY" &&
                    (bill.status === "LINK" || bill.status === "UNLINK"))
                ) {
                  goService = false;
                }
              }
            });
          }

          if (!goService) {
            if (
              !isOciProduct &&
              getProductFromSessionStorage() !== "WRAPSODY"
            ) {
              notifyError("subscriptionType.alreadyCreatedMsg");
              return;
            }
          }

          try {
            insertInicisModule(); // 반드시 await 필요
            // @ts-expect-error
            if (!window?.INIStdPay) {
              notifyError("결제 모듈이 정상적으로 로드되지 않았습니다.");
              return;
            }
            // @ts-expect-error
            window?.INIStdPay.pay("inicisForm", {
              success: function (data: any) {
                console.log("결제 성공", data);
              },
              error: function (data: any) {
                console.error("결제 실패", data);
              },
              close: function () {
                console.log("결제창 닫힘");
              },
            });
          } catch (err) {
            console.error("이니시스 모듈 로딩 실패", err);
            notifyError("결제 모듈 로딩 중 오류가 발생했습니다.");
          }
        } else {
          // @ts-expect-error
          window?.INIStdPay.pay("inicisForm", {
            success: function (data: any) {
              console.log("결제 성공", data);
            },
            error: function (data: any) {
              console.error("결제 실패", data);
            },
            close: function () {
              console.log("결제창 닫힘");
            },
          });
        }
      });
    }
  }, [payData]);
  const { t } = useTranslation();
  const billPrint_msg = t(
    "siteManagement.paymentHistory.bill.detail.includeVat"
  );

  return (
    <>
      {/* 이니시스 PC 결제 폼 */}
      <form
        className="inicisForm"
        id="inicisForm"
        name="inicisForm"
        method="POST"
        style={{ display: "none" }}
      >
        <input name="version" readOnly value="1.0" />
        <input name="mid" readOnly value={payData?.mid} />
        {/* <input name="mid" readOnly value={"INIBillTst"} /> */}
        <input name="goodname" readOnly required={true} value={goodName} />
        <input name="oid" readOnly value={payData?.oid} />
        <input name="price" readOnly value={payData?.price} />
        <input name="currency" readOnly value={currency} />
        <input name="buyername" readOnly value={payData?.buyerName} />
        <input name="buyertel" readOnly value="010-0000-0000" />
        <input name="buyeremail" readOnly value={payData?.buyerEmail} />
        <input name="timestamp" readOnly value={payData?.timestamp} />
        <input name="signature" readOnly value={payData?.signature} />
        <input name="returnUrl" readOnly value={resolvedReturnUrl} />
        <input name="mKey" readOnly value={payData?.mKey} />
        <input name="gopaymethod" readOnly value="Card" />
        <input name="acceptmethod" readOnly value="below1000:billauth(card)" />
        <input name="billPrint_msg" readOnly value={billPrint_msg} />
        <input name="languageView" readOnly value={lang} />
        <input name="charset" readOnly value="UTF-8" />
        <input name="merchantData" readOnly value="" />
        <input name="tax" readOnly value="0" />
        <input name="taxfree" readOnly value="0" />
        <input type="hidden" readOnly name="closeUrl" value={closeUrl} />
      </form>

      {/* 이니시스 MOBILR 결제 폼 */}
      {/* <form
        name="mobileweb"
        method="post"
        acceptCharset="euc-kr"
        ref={mobilePurchaseRef}
      >
        <input
          type="text"
          readOnly
          name="P_NEXT_URL"
          value={payData.returnUrl}
        />
        <input
          type="text"
          readOnly
          name="P_INI_PAYMENT"
          value={payServerTextMb(payData.payStatus)}
        />
        <input
          type="text"
          readOnly
          name="P_MID"
          value={isTest ? "INIpayTest" : payData.mid}
        />
        <input type="text" readOnly name="P_OID" value={oid} />
        <input
          type="text"
          readOnly
          name="P_GOODS"
          value={payData.productName}
        />
        <input type="text" readOnly name="P_AMT" value={payData.productPrice} />
        <input type="text" readOnly name="P_UNAME" value={payData.buyerName} /> */}

      {/* 휴대폰결제 필수 [1:컨텐츠, 2:실물] */}
      {/* {payData.payStatus === 2 && (
          <input
            type="text"
            readOnly
            name="P_HPP_METHOD"
            value={payData.telStatus}
          />
        )} */}
      {/* </form> */}

      <span onClick={onClickPurchase}>{children}</span>
    </>
  );
};

export default ReactInicis;
